import {Apollo, gql} from 'apollo-angular';
import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ActivatedRoute} from "@angular/router";

import {AuthenticationService} from "../../authentication/authentication.service";
import {ProgressService} from "../../core/services/progress.service";

import {EventService} from "./event.service";

@Injectable()
export class PostService {

    constructor(
        private eventService: EventService,
        private http: HttpClient,
        private router: ActivatedRoute,
        private apollo: Apollo,
        private authService: AuthenticationService,
        private progressService: ProgressService,
    ) {}

    generatePostUrlKey(postTitle, pagePosts) {
        var newKey = '';
        if(postTitle) {
            newKey = postTitle.replace(/\s+/g, '-').toLowerCase();
        }
        var count = 1;
        var newKeyBase = newKey;

        while(this.checkIfUrlKeyAlreadyExist(newKey, pagePosts)) {
            newKey = newKeyBase + '-' + count;
            count++;
        }

        return newKey;
    }

    checkIfUrlKeyAlreadyExist(urlKey, pagePosts) {
        if(!!pagePosts) {
            for (var i = 0; i < pagePosts.length; i++) {
                if(pagePosts[i].urlKey && pagePosts[i].urlKey === urlKey) {
                    return true;
                }
            }
        }
        return false;
    }

    // Reloads the posts section from GraphQL
    reloadPosts() {
        this.progressService.startProgress(false);
        var isTeam = !!this.router.snapshot.queryParams['isTeam'];
        var partialQuery;
        if (isTeam) {
            let teamId = this.eventService.selectedEvent.gql.Participant[0].team.teamId;
            partialQuery = `Team (teamId: ${teamId}) {
                fundraiser {
                  fundraiserPosts {
                    fundraiserPostId
                    publishedFl
                    urlKey
                    rawHtmlContent
                    htmlContent
                    publishedDate
                    title
                    fundraiserPostComments {
                       comment
                    }
                  }
                }
              }`;
        } else {
            let participantId = this.eventService.selectedEvent.participantId;
            partialQuery = `Participant(participantId: ${participantId}) {
                        participantId
                        individualConstituent {
                          individualConstituentId
                        }
                        event {
                          eventId
                        }
                        fundraiser {
                          fundraiserPosts {
                            fundraiserPostId
                            publishedFl
                            urlKey
                            rawHtmlContent
                            htmlContent
                            publishedDate
                            title
                            fundraiserPostComments {
                               comment
                            }
                          }
                        }
                      }`;
        }
        var query = gql`
                  query EventRelatedQuery {
                    ${partialQuery}
                  }`;

        this.apollo.query<any>({
            fetchPolicy: "network-only",
            query: query
        }).subscribe(res => {
            if (isTeam) {
                this.eventService.selectedEvent.gql.Participant[0].team.fundraiser.fundraiserPosts = res.data.Team[0].fundraiser.fundraiserPosts;
            } else {
                this.eventService.selectedEvent.gql.Participant[0].fundraiser.fundraiserPosts = res.data.Participant[0].fundraiser.fundraiserPosts;
            }
            this.progressService.stopProgress(false);
        });
    }
}
